import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  aboutForm: FormGroup;
  isSubmitted: boolean = false;
  isLoading: boolean = false;
  aiSequenceForm: FormGroup
  defaultValuesAISequence = {
    option: '',
    purpose: '',
    value_in_msg: '',
    max_body_length: 100,
    creativity_index: 50,
    is_spintax: 0,
    tone: 'professional',
    paragraph: 1,
    steps: 1,
    variants: 1,
    screen:'options'
  };
  previousSequences: any[] = [];
  sequencesSteps: any[] = [];
  campaignId:any;
  subject: any;
  body:any;
  errMsg: any = '';
  blankVariantIndex: any;
  isSaveAndNext: boolean = false;
  isSaveSequences = new BehaviorSubject<Boolean>(false);
  isOnbStepUpdate = new BehaviorSubject<Boolean>(false);
  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService
  ) {
    this.aboutForm = this.formBuilder.group({
      company_domain: ['', Validators.required],
      describes_you: ['', Validators.required],
      describes_you_other: [''],
      main_goal: ['', Validators.required],
      main_goal_other: [''],
      hear_about_us: ['', Validators.required],
      hear_about_us_other: [''],
      tools: [[], Validators.required],
      tools_other: [''],
    });

    this.aiSequenceForm = this.formBuilder.group({
      screen:["options"],
      option: ['', Validators.required],
      purpose: ['', Validators.required],
      value_in_msg: ['', Validators.required],
      max_body_length: [100],
      creativity_index: [50],
      is_spintax: [0],
      tone: ['professional'],
      paragraph: [1],
      steps: [1],
      variants: [1]
    })
  }
  patchToDefaults() {
    /**
     * Patches all values in a form to their corresponding default values.
     *
     * @param form The form to patch.
     * @param defaults A dictionary containing the default values for each key.
     */
    let form: FormGroup = this.aiSequenceForm;
    let defaults: any = this.defaultValuesAISequence;
    for (const key of Object.keys(form.controls)) {
      if (key in defaults) {
        form.patchValue({ [key]: defaults[key] });
      }
    }
  }

  submitForm(): Observable<any> {
    this.isSubmitted = true;
    Object.entries(this.aboutForm.controls).forEach(([key, value]) => {
      this.aboutForm.controls[key].markAsDirty();
      this.aboutForm.controls[key].markAsTouched();
    });
    console.log('form', this.aboutForm);
    let company_domain;
    let describes_you_value;
    let main_goal_value;
    let hear_about_us_value;
    let tools_value;
    if (!this.aboutForm.value.company_domain) {
      this.aboutForm.controls['company_domain'].setErrors({
        required: true,
      });

      this.isLoading = false;
    } else {
      company_domain = this.aboutForm.value.company_domain;
    }
    if (this.aboutForm.value.describes_you == 'Other') {
      if (!this.aboutForm.value.describes_you_other) {
        this.aboutForm.controls['describes_you_other'].setErrors({
          required: true,
        });

        this.isLoading = false;
      } else {
        describes_you_value = this.aboutForm.value.describes_you_other;
      }
    } else {
      describes_you_value = this.aboutForm.value.describes_you;
    }

    if (this.aboutForm.value.main_goal == 'Other') {
      if (!this.aboutForm.value.main_goal_other) {
        this.aboutForm.controls['main_goal_other'].setErrors({
          required: true,
        });
        this.isLoading = false;
      } else {
        main_goal_value = this.aboutForm.value.main_goal_other;
      }
    } else {
      main_goal_value = this.aboutForm.value.main_goal;
    }
    if (this.aboutForm.value.hear_about_us == 'Other') {
      if (!this.aboutForm.value.hear_about_us_other) {
        this.aboutForm.controls['hear_about_us_other'].setErrors({
          required: true,
        });
        this.isLoading = false;
      } else {
        hear_about_us_value = this.aboutForm.value.hear_about_us_other;
      }
    } else {
      hear_about_us_value = this.aboutForm.value.hear_about_us;
    }
    if (this.aboutForm.value.tools.includes('Other')) {
      if (!this.aboutForm.value.tools_other) {
        this.aboutForm.controls['tools_other'].setErrors({
          required: true,
        });
        this.isLoading = false;
      } else {
        tools_value = [
          ...this.aboutForm.value.tools,
          this.aboutForm.value.tools_other,
        ];
      }
    } else {
      tools_value = this.aboutForm.value.tools;
    }

    if (this.aboutForm.invalid || this.isLoading) return of({ success: false });
    this.isLoading = true;
    let data = {
      company_domain: company_domain,
      best_describe: describes_you_value,
      main_goal: main_goal_value,
      about_us: hear_about_us_value,
      tools: tools_value,
    };
    console.log({data})
    return this.api.postData('walkthrough', data)
  }
}
